import { Icon, Button } from '@/ui/components/base';
import './menuItem.css';

interface MenuItemProps {
    children: string;
    icon: string;
    onClick: () => void;
    noArrow?: boolean;
}

export const MenuItem = ({ icon, onClick, children }: MenuItemProps) => {
    return (
        // <Button variant="secondary" onClick={onClick} className="menu-item">
        //     <Icon src={icon} alt={`${children} icon`} size="medium" />
        //     <div className="menu-item__text">{children}</div>
        //     <div className="menu-item__spacer"></div>
        //     {!noArrow && <Icon src={chevronIcon} alt="Chevron" size="medium" />}
        // </Button>

        <Button className="menu-item" rounding="large" variant="secondary" onClick={onClick}>
            <Icon src={icon} size="extra-large" />
            {children}
        </Button>
    );
};
